module.exports = () => {
    if (window.location.host === "cntl-dashboard-browser-prd.contele.com.br") {
      return "https://webapi.contelege.com.br";
    } else if (window.location.host === "cntl-staging-subscription-www.contele.com.br") {
      return "https://gv-staging-billing-api.contele.com.br";
    } else {
      return "http://localhost:8009";
    }
  }